function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../messages';
export const renderHeader = (headerMessage)=>/*#__PURE__*/ _jsx("header", {
        className: "pageHeader",
        children: /*#__PURE__*/ _jsx("h1", {
            className: "text--h2 align-items-center px-8 text-align--center",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, headerMessage))
        })
    });
export const renderInfo = (infoMessage, email)=>/*#__PURE__*/ _jsx("p", {
        className: "mb-6 text-align--center",
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, infoMessage), {
            values: {
                email: /*#__PURE__*/ _jsx("b", {
                    children: email
                })
            }
        }))
    });
export const renderCheckSpam = (className = null)=>/*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsxs("b", {
                className: "note",
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.notes.note)),
                    ":"
                ]
            }),
            ' ',
            /*#__PURE__*/ _jsx("span", {
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.notes.checkSpamFolder))
            })
        ]
    });
